/** Avatars employés BZ (fichiers à la racine de /public). */
const avatarMap: Record<string, string> = {
  'dbourassa@bzinc.ca': '/DB.png',
  'dany bourassa': '/DB.png',
  'Dany Bourassa': '/DB.png',
  'ehains@bzinc.ca': '/EH.png',
  'eric hains': '/EH.png',
  'Eric Hains': '/EH.png',
  'jpleclerc@bzinc.ca': '/JP.png',
  'jleclerc@bzinc.ca': '/JP.png',
  'jean-pierre leclerc': '/JP.png',
  'Jean-Pierre Leclerc': '/JP.png',
  'agiroux@bzinc.ca': '/AG-transparent.png',
  'antoine giroux': '/AG-transparent.png',
  'Antoine Giroux': '/AG-transparent.png',
  'edurand@bzinc.ca': '/ED.png',
  'eric durand': '/ED.png',
  'Eric Durand': '/ED.png',
  'equal@bzinc.ca': '/EQ.png',
  'emilie quintal': '/EQ.png',
  'Emilie Quintal': '/EQ.png',
  'fmarquis@bzinc.ca': '/FM.png',
  'francis marquis': '/FM.png',
  'Francis Marquis': '/FM.png',
  'fdelisle@bzinc.ca': '/FP.png',
  'francois delisle': '/FP.png',
  'Francois Delisle': '/FP.png',
  'François Delisle': '/FP.png',
  'jmartel@bzinc.ca': '/JM.png',
  'jerome martel': '/JM.png',
  'Jerome Martel': '/JM.png',
  'rosalie emond': '/RE.png',
  'Rosalie Emond': '/RE.png',
  'jmcaouette@bzinc.ca': '/JMC.png',
  'jcaouette@bzinc.ca': '/JMC.png',
  'jean-michel caouette': '/JMC.png',
  'Jean-Michel Caouette': '/JMC.png',
  'mpelletier@bzinc.ca': '/MP.png',
  'melissa pelletier': '/MP.png',
  'Melissa Pelletier': '/MP.png',
  'rdelisle@bzinc.ca': '/RD.png',
  'richard delisle': '/RD.png',
  'Richard Delisle': '/RD.png',
  'vbourassa@bzinc.ca': '/VB.png',
  'vincent bourassa': '/VB.png',
  'Vincent Bourassa': '/VB.png',
  'stephane.paradis@bzinc.ca': '/SP.png',
  'stephane paradis': '/SP.png',
  'Stéphane Paradis': '/SP.png',
  'yannick moreau': '/DB.png',
  'ymoreau@bzinc.ca': '/DB.png',
};

function titleCaseName(name: string) {
  return name
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function getBzUserAvatar(user?: { email?: string | null; name?: string | null }): string | null {
  if (!user) return null;

  if (user.email) {
    const emailLower = user.email.toLowerCase();
    if (avatarMap[emailLower]) return avatarMap[emailLower];
  }

  if (user.name) {
    if (avatarMap[user.name]) return avatarMap[user.name];
    const lower = user.name.toLowerCase();
    if (avatarMap[lower]) return avatarMap[lower];
    const formatted = titleCaseName(user.name);
    if (avatarMap[formatted]) return avatarMap[formatted];
  }

  return null;
}

export function getBzUserInitials(name: string) {
  return name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
